// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"Carousel_imgContainer__3JzzZ","swiper-slide":"Carousel_swiper-slide__1THha"};